import {
  instanceLogin as axiosLogin,
  instance as axios,
} from "../../configs/axios";

export default {
  login: (credentials) => axiosLogin.post("/Auth/Login", credentials),
  getMenu: () => axios.get("Auth/GetMenu"),
  changePassword: (param) => axios.post("Auth/ChangePassword", param),
  forgotPassword: (email) => axios.post(`Auth/ForgotPassword?email=${email}`),
  checkVersion: () => axiosLogin.get("Auth/CheckVersion"),
  checkAuthorization: (url) => axios.get(`Auth/CheckAuthorization?url=${url}`),
};
